import {Component} from '@angular/core';

@Component({
  selector: 'app-three-dots',
  templateUrl: './three-dots.component.html',
  styleUrls: ['./three-dots.component.scss']
})
export class ThreeDotsComponent {
}
